import State from '../core/State';
import initialState from '../initialState';

export const setFatalError = (error: Error, solveTo: string) => (state: State): State => ({
  ...state,
  fatalError: {
    error,
    solveTo,
  },
});

export const disposeFatalError = () => (state: State): State => ({
  ...state,
  fatalError: initialState.fatalError,
});
